import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.tabbed-slider__splide' ).length ) {
        const sliders = [];
        $( '.tabbed-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            arrows: true,
            gap: '2rem',
            perPage: 1,
            focus: 'center',
            padding: '25vw',
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1270: {
                padding: '20vw',
              },
              1024: {
                padding: '17rem',
              },
              768: {
                perPage: 1,
                gap: '1rem',
                padding: '1rem',
              },
            },
          } );

          const splideNav = slider.root.querySelector( '.tabbed-slider__splide-nav' );

          // slider.on( 'overflow', function( isOverflow ) {
          //   console.log( isOverflow );
          //   slider.options = {
          //     arrows: isOverflow,
          //     drag: isOverflow,
          //     clones: isOverflow ? undefined : 0,
          //     focus: 0,
          //   };
          //   if ( !isOverflow ) {
          //     splideNav.style.display = 'none';
          //   } else {
          //     splideNav.style.display = 'flex';
          //   }
          // } );

          slider.mount();

          const sliderId = $( this ).attr( 'id' );
          sliders[sliderId] = slider;

          let currentSlider = $( '.tabbed-slider-tabs__tab-content' ).attr( 'id' );

          $( document ).on( 'change', '.js-tabbed-slider-tabs__form', function( event ) {
            event.preventDefault();
            const formData = $( this ).serializeArray();

            let updatedSlider = currentSlider;
            let inputType = '';
            $( formData ).each( function( index, value ) {
              if ( value.value !== currentSlider ) {
                updatedSlider = value.value;
                inputType = value.name;
              }
            } );

            /* Show the slider and update aria attribute */
            $( `#${currentSlider}` ).removeClass( 'is-open' );
            $( `#${currentSlider}` ).attr( 'aria-hidden', true );
            $( `#${updatedSlider}` ).addClass( 'is-open' );
            $( `#${updatedSlider}` ).attr( 'aria-hidden', false );

            $( `#${updatedSlider}` ).closest( 'section' ).find( `.tabbed-slider-tabs__tab-content:not(#${updatedSlider}) *` ).attr( 'tabindex', '-1' );
            $( `#${updatedSlider} *` ).removeAttr( 'tabindex' );

            currentSlider = updatedSlider;

            const sliderId = $( `[data-tab-id=${currentSlider}]` ).attr( 'id' );

            /* refresh selected slider so the splide arrows and progress bar are displayed */
            sliders[sliderId].refresh();

            /* make sure form fields have same value */
            if ( inputType === 'tabbed-slider-item-select' ) {
              $( this ).find( `.tabbed-slider__radio-input[value="tabbed-slider-tabs-tab-${currentSlider}"]` ).prop( 'checked', true );
            } else {
              $( '.tabbed-slider' ).find( 'select' ).val( currentSlider );
            }

            const select = $( this ).find( '.tabbed-slider-tabs__select' );
            const announcement = $( this ).find( '.tabbed-slider-tabs__announcement' );
            /* announce the slider has been displayed */
            const selectedTitle = $( `#${select.attr( 'id' )} option:selected` ).text();
            announcement.text( `${selectedTitle} slider is displayed` );

            return false;
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'tabbed-slider', COMPONENT );
} )( app );
